  <!-- header area start -->
  <main>
    <div class="header2">
      <div class="">
          <div class="topHeader">
              <div class="logo">
                  <img src="./img/autotrader.png" alt="">
  
                  <i class="fa-solid fa-bars"></i>
              </div>
              <div class="search">
                  <input type="text" class="form-control">
                  <button class="btn" type="button"><i class="fa-solid fa-magnifying-glass"></i> Search</button>
              </div>
  
              <div class="login">
                  <ul class="log">
                      <li>
                          <div class="dropdown">
                              <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                English
                              </button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item" [routerLink]="['/'+ handle + '/moreAds']">Arabic</a></li>
                                <li><a class="dropdown-item" [routerLink]="['/'+ handle + '/moreAds']">French</a></li>
                                <li><a class="dropdown-item" [routerLink]="['/'+ handle + '/moreAds']">German</a></li>
                              </ul>
                            </div>
                      </li>
  
                      <li>
                          <a [routerLink]="['/'+ handle + '/moreAds']">
                              <img src=".//img/Vector.png" alt="">
                              Login
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="bottomHeader">
              <ul>
                  <li><a [routerLink]="['/'+ handle + '/moreAds']"><i class="fa-solid fa-house"></i> Home</a></li>
                  <li><a [routerLink]="['/'+ handle + '/moreAds']">Used Cars</a></li>
                  <li><a [routerLink]="['/'+ handle + '/moreAds']">Compare</a></li>
                  <li><a [routerLink]="['/'+ handle + '/moreAds']">Deals</a></li>
              </ul>
  
              <a [routerLink]="['/'+ handle + '/moreAds']">
                  <button class="btn" type="button">Sell Your Car</button>
              </a>
              
          </div>
      </div>
  </div>
  <!-- header area end -->
  
  <!-- hero area start -->
  <section class="heroSplit">
      <div class="firstWrapperOverlay"></div>
      <div class="secondWrapperOverlay"></div>
      <div class="container">
          <div class="row">
              <div class="col-md-6">
  
                  <div class="sectionWrapperLeft">
                      <h2>Find Your Dream Car?</h2>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.At vero eos et accusamus et iusto.</p>
                      <a [routerLink]="['/'+ handle + '/moreAds']">
                          <button class="btn btnRed" type="button">SEARCH</button>
                      </a>
                  </div>
                  
              </div>
  
              <div class="col-md-6">
  
                  <div class="sectionWrapperRight">
                      <h2>Want To Sale Your Car ?
                      </h2>
                      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.At vero eos et accusamus et iusto.</p>
                      <a [routerLink]="['/'+ handle + '/moreAds']">
                          <button class="btn btnBlue" type="button">HIRE SERVICES</button>
                      </a>
                  </div>
                 
              </div>
  
          </div>
      </div>
  </section>
  <!-- hero area end -->
  
  
  <!-- filter list area start -->
  
  <div class="filterList">
      <div class="container">
          <div class="input-group">
  
              <div class="row">
                  <div class="col-md-3">
                      <label for="">Keyword</label>
                      <input type="text" class="form-control" placeholder="Eg Honda civic,ford,audi">
                  </div>
                  <div class="col-md-3">
                      <label for="">Select Make</label>
                      <select class="form-select" aria-label="Default select example">
                          <option selected>BMW</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                  </div>
  
                  <div class="col-md-3">
                      <label for="">Select Year</label>
                      <select class="form-select" aria-label="Default select example">
                          <option selected>Year</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                  </div>
  
                  <div class="col-md-3">
                      <label for="">Select Location</label>
                      <select class="form-select" aria-label="Default select example">
                          <option selected>India</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                  </div>
  
              </div>
  
              <a [routerLink]="['/'+ handle + '/moreAds']">
                  <button class="btn searchBtn" type="button">SEARCH NOW</button>
              </a>
              
            </div>
      </div>
  </div>
  
  <!-- filter list area end -->
  
  <!-- listing area start -->
  <div class="listingArea">
      <div class="container">
  
          <div class="headingArea">
              <div class="left">
                  <h5>Lateat <span>Featured</span> Ads</h5>
              </div>
  
              <div class="right">
                  <ul class="nav nav-pills" id="pills-tab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Honda</button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <!-- data-bs-target="#pills-profile" -->
                        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"  data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">BMW</button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <!-- data-bs-target="#pills-contact" -->
                        <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"  data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Audi</button>
                      </li>
                    
                    </ul>
  
              </div>
          </div>
  
          <div class="tab-content" id="pills-tabContent">
             <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                  <div class="row">
                    <ng-container  *ngFor="let list of dealerListingData">
                      <div class="col-md-4" (click)="navigate(list?.ListingHandle)">
                          <div class="listingCard">
                               <div class="imageWrapper">
                                <mdb-carousel class="carousel slide carousel-fade">
                                    <mdb-carousel-item *ngFor="let item of getImages(list)">
                                      <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                                        class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                                      <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                                        (error)="item.MediaURL = null">
                                        >
                                        <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                                        Your browser does not support the video tag.
                                      </video>
                                      <h4 *ngIf="!item.MediaURL">
                                        <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                                      </h4>
                                    </mdb-carousel-item>
                                  </mdb-carousel>
                                  <span class="price" style="z-index: 10 !important;">{{dealerData?.PrimaryCurrencyText}}{{list.AskingPrice}}</span>
                                  <span class="tag" style="z-index: 10 !important;">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                        {{list?.ListingHeader}}
                                      </div>
                                      <a>
                                          <h5>{{list?.Description.slice(0, 10)}}</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          {{list.Location}}
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          {{list.MakeMonth}} {{list.MakeYear}}
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
                    </ng-container>
                    </div>
               
              </div>
  
              <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                  <div class="row">
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                  </div>
              </div>
  
              <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
                  <div class="row">
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="listingCard">
  
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                                  <span class="price">$205,000</span>
                                  <span class="tag">FEATURED</span>
                              </div>
  
                              <div class="bottomDetails">
                                  <div class="paddingSection">
                                      <div class="type">
                                          Sports & Equipment
                                      </div>
                                      <a>
                                          <h5>Honda Civic 2017 Sports Edition</h5>
                                      </a>
  
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
  
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i> 
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-car"></i>
                                              Sedan
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-brush"></i>
                                              Blue
                                          </li>
                                      </ul>
                                  </div>
                                  
                                  <div class="bottomInfo">
                                      <p>
                                          <i class="fa-duotone fa-calendar-days"></i>
                                          5 Days ago
                                      </p>
                                  
                                  </div>
                              </div>
  
                          </div>
                      </div>
  
                  </div>
              </div>
              
            </div>
  
          
      </div>
  </div>
  <!-- listing area end -->
  
  
  <!-- top dealer area start -->
  <div class="listingArea pt-3">
      <div class="container">
  
          <div class="headingArea">
              <div class="left">
                  <h5>Top  <span>Dealer </span> Ads</h5>
              </div>
  
              <div class="right">
                  <ul class="nav nav-pills" id="pills-tab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Most Popular</button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Trending</button>
                      </li>
                  </ul>
              </div>
          </div>
  
          <div class="tab-content" id="pills-tabContent">
  
              <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
  
                  <div class="row">
                      <div class="col-md-4">
  
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
  
                      </div>
  
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                  </div>
  
              </div>
  
              <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                  <div class="row">
                      <div class="col-md-4">
  
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
  
                      </div>
  
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/12.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/11.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="col-md-4">
                          <div class="topDealerCard">
                              <div class="imageWrapper">
                                  <img src="./img/10.jpg" alt="">
                              </div>
                              <div class="bottomDetails">
                                  <div class="info">
                                      <ul>
                                          <li>
                                              <i class="fa-light fa-engine"></i>
                                              Diesel
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-road"></i>
                                              3500KM
                                          </li>
  
                                          <li>
                                              <i class="fa-light fa-closed-captioning"></i>
                                              2000cc
                                          </li>
  
                                      </ul>
                                  </div>
  
                                  <div class="dealerInfo">
                                      <a>
                                          <h5>2016 McLaren 570S Coupe</h5>
                                      </a>
                                      <div class="location">
                                          <i class="fa-solid fa-location-dot"></i>
                                          Model Town Link Road London
                                      </div>
                                      <p>Till the one day when the lady met this fellow and they knew it was much more than</p>
  
                                      <div class="bottomContact">
                                          <h5>$370</h5>
                                          <a>
                                              <button class="btn btn1" type="button">
                                                  <i class="fa-solid fa-phone"></i>
                                                  View Details
                                              </button>
                                          </a>
                                      </div>
                                      
                                  </div>
  
  
                              </div>
                          </div>
                      </div>
  
                  </div>
              </div>
              
            </div>
  
          
      </div>
  </div>
  <!-- top dealer area end -->
  
  <footer>
      <div class="container">
          <div class="row">
              <div class="col-md-5">
                  <img src="./img/autotrader.png" class="logo" alt="">
                  <p class="mb-4">CarSpot Automotive Car Classified WordPress Theme is flexible and powerful Car Classified wordpress Theme for your all automotive & car listing business needs.</p>
                  <ul class="social">
                      <li><a><i class="fa-brands fa-facebook-f"></i> </a></li>
                      <li><a><i class="fa-brands fa-twitter"></i> </a></li>
                      <li><a><i class="fa-brands fa-linkedin-in"></i> </a></li>
                      <li><a><i class="fa-brands fa-google-plus-g"></i></a></li>
                      <li><a><i class="fa-brands fa-youtube"></i> </a></li>
                  </ul>
              </div>
              <div class="col-md-4">
                  <h5>Quick Links</h5>
  
                  <div class="d-flex">
                      <ul>
                          <li><a>Home</a></li>
                          <li><a>About Us</a></li>
                          <li><a>Comparison</a></li>
                          <li><a>Expert Reviews</a></li>
                      </ul>
  
                      <ul>
                          <li><a>Elements</a></li>
                          <li><a>Checkout</a></li>
                          <li><a>Packages</a></li>
                          <li><a>Contact Us</a></li>
                      </ul>
                  </div>
               
              </div>
              <div class="col-md-3">
                  <h5>Get Our Apps</h5>
                  <a  class="google">
                      <img src="./img/google.png" alt="">
                  </a>
                  <a  class="apple">
                      <img src="./img/apple.png" alt="">
                  </a>
              </div>
  
              <div class="col-12 text-center">
                  <p class="copyright">© Copyright 2022  </p>
              </div>
          </div>
      </div>
  </footer>
  </main>
  
  